angular
	.module 'App.Repository'

.factory 'ShopOpeningHoursRepository', ['BaseRepository', (BaseRepository) ->
		class ShopOpeningHoursRepository extends BaseRepository
			@resource = '/shop_opening_hours'
			@isRestricted = true

		return new ShopOpeningHoursRepository
	]
